import { useEffect } from 'react';
import AgSachbearbeiterDashboard from '../ag_sachbearbeiter/AgSachbearbeiterDashboard';

export default function LandingPageAgSachbearbeiter() {

    useEffect(() => {
    }, []);

    return (
        <>
            <AgSachbearbeiterDashboard />
        </>
    );
}
